import { AxiosResponse } from "axios";
import axiosInstance from "../../../interceptors/axiosInstance";
import { ListResponseDto } from "../../../dtos/ListResponseDto";
import { ValueDto } from "../../detalleMutuo/models/garantias";
import { EjecutarQueryRequestDto, ParametroConsulta } from "../models/querys";


const getQuerys = async () => {
    const response: AxiosResponse<ListResponseDto<ValueDto>> = await axiosInstance.get(`siscred-api-reportes/v1/reporte-query/obtener-query`);
    return response;
}

const getParametrosQuery = async (idConsult: string) => {
    const response: AxiosResponse<ListResponseDto<ParametroConsulta>> = await axiosInstance.get(`siscred-api-reportes/v1/reporte-query/obtener-parametros-query`, {
        params: {
            idConsult: idConsult
        }
    });
    return response;
}

const getResultQuery = async (request: EjecutarQueryRequestDto) => {
    const response: AxiosResponse<ListResponseDto<Record<string, any>>> = await axiosInstance.post(
        `siscred-api-reportes/v1/reporte-query/ejecutar-query`,
        request
    );
    return response;
};

const getReporteCarteraTotal = async () => {
    const response: AxiosResponse<Blob> = await axiosInstance.post(
        `siscred-api-reportes/v1/reportes/ReporteCarteraTotal`,
        {},
        {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    );
    return response;
};

export {
    getQuerys,
    getParametrosQuery,
    getResultQuery,
    getReporteCarteraTotal
}